<template>
    <PageEvent
        v-if="route.params.id && typeof route.params.id === 'string'"
        :event-id="route.params.id"
    />
</template>

<script setup lang="ts">
const route = useRoute();
</script>
